import { useApplicationsList } from '../components/ApplicationContext';
import { useState, useEffect } from 'react';
/**
 * Hook to get the list of configured product names from the database
 * Returns an array of product names (e.g., ['forecasting', 'remote'])
 */
export const useProductsList = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const getApplications = useApplicationsList();
    useEffect(() => {
        const loadProducts = async () => {
            try {
                const apps = await getApplications();
                const applications = apps;
                // Extract product names from applications (excluding RBAC)
                const productNames = applications
                    .filter((app) => app?.details?.productName && app.name !== 'RBAC')
                    .map((app) => app.details.productName)
                    .filter(Boolean);
                setProducts(productNames);
            }
            catch (error) {
                console.error('Error loading products:', error);
                setProducts([]);
            }
            finally {
                setLoading(false);
            }
        };
        loadProducts();
    }, [getApplications]);
    return { products, loading };
};
/**
 * Hook to get the first product from the database
 * Useful for default redirects
 */
export const useFirstProduct = () => {
    const { products, loading } = useProductsList();
    return {
        firstProduct: products[0] || '',
        loading
    };
};
